import React from "react";
import { styled, IconText, css } from "@sourceful/shared-components";
import toRem from "@styles/postprocess/conversion/to-rem";
import { ProductTag } from "@sourceful/shared-types";

const ProductTagsWrapper = styled("ul", {
  margin: "0",
  padding: "0",
  listStyle: "none",
  display: "grid",
  gridTemplateColumns: "1fr",
  gridGap: toRem(15),

  "@sm": {
    gridTemplateColumns: "1fr 1fr",
  },
});

const liCss = css({
  display: "flex",
});

interface ProductTagsProps {
  tags: ProductTag[];
}

const ProductTags = ({ tags }: ProductTagsProps) => {
  return (
    <ProductTagsWrapper>
      {tags.map(tag => {
        return (
          <li key={tag.label} className={liCss()}>
            <IconText
              text={tag.label}
              primaryIcon={tag.iconName}
              css={{
                fontSize: toRem(12),
                svg: { width: toRem(20), height: toRem(20), marginRight: toRem(7) },
              }}
            />
          </li>
        );
      })}
    </ProductTagsWrapper>
  );
};

export default ProductTags;
